import Vue from 'vue';
import Vuex from 'vuex';
import modules from '@/store/modules';
import {RootState} from '@/types';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  plugins: [
    // createPersistedState({
    //   paths: ['auth.user', 'drawer'],
    // }),
  ],
  modules: {
    ...modules,
  },
  state: {
    drawer: true,
    clipped: false,
  },
  mutations: {
    setDrawer(state, value) {
      state.drawer = value;
    },
    setClipped(state, value) {
      state.clipped = value;
    },
  },
  actions: {},
  getters: {
    drawer: state => state.drawer,
    clipped: state => state.clipped,
  },
});
